import React from 'react';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Section = styled.section`
  padding: 5rem 1rem;
  background: var(--background-light);
`;

const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center;
  max-width: 720px;
  margin: 0 auto 3rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 500px) { grid-template-columns: 1fr; }
`;

const Card = styled.figure`
  margin: 0;
  background: rgba(0,0,0,0.35);
  border: 1px solid rgba(0,153,0,0.2);
  border-radius: 1.25rem;
  aspect-ratio: 1;
  display: grid; place-items: center;
  padding: 1.5rem;
  transition: transform 0.25s ease, border-color 0.25s ease;
  &:hover { transform: translateY(-3px); border-color: var(--primary-color); }
  img { max-width: 78%; max-height: 78%; object-fit: contain; display: block; }
  figcaption {
    margin-top: 0.5rem;
    color: var(--text-secondary);
    font-size: 0.75rem;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;

const items = [
  { src: '/img/product-flash-1.png', alt: `${siteConfig.brand.name} — flash USDT software product screen 1`, cap: 'License panel' },
  { src: '/img/product-flash-2.png', alt: `${siteConfig.brand.name} — flash USDT TRC-20 transaction preview`,  cap: 'TRC-20 flash' },
  { src: '/img/product-flash-3.png', alt: `${siteConfig.brand.name} — flash USDT ERC-20 wallet balance`,       cap: 'ERC-20 flash' },
  { src: '/img/product-flash-4.png', alt: `${siteConfig.brand.name} — flash USDT BEP-20 delivery confirmation`, cap: 'BEP-20 flash' },
];

const ProductShowcase: React.FC = () => (
  <Section id="product">
    <Inner>
      <Head>
        <div className="tag">Inside the software</div>
        <h2>What your <span>flash USDT license</span> unlocks</h2>
        <p>Screens from the flash USDT software. Multi-chain support, wallet-native flashing, and clear transaction previews across TRC-20, ERC-20 and BEP-20.</p>
      </Head>
      <Grid>
        {items.map((it) => (
          <Card key={it.src}>
            <img src={it.src} alt={it.alt} loading="lazy" />
            <figcaption>{it.cap}</figcaption>
          </Card>
        ))}
      </Grid>
    </Inner>
  </Section>
);

export default ProductShowcase;
